import { serializer } from "shared/api/serializer/serializer"

import { DynamicTypeOptions } from "json-api-serializer"

import { createResponseTransformer } from "./createResponseTransformer"

export const responseTransformer = createResponseTransformer(json => {
  return serializer.deserialize(
    { type: (data: { type: string }) => data.type } as DynamicTypeOptions,
    json
  )
})
